import { TransactionTeam } from '../../models/TransactionTeamModels';
import { TransactionRole } from '../../models/AIMModels';
import { TransactionTeamLeadParams, TransactionTeamTransactionRoleParams } from '../../models/APIModels';
import { ENV } from '../../envUtils';

/**
 * Endpoint path builders for transaction team CRUD, lifecycle transitions, lead management, and transaction editing operations.
 *
 * Each property is either a plain URL string or a function that builds a path from ENV combined with the transaction team's aim value and an action segment.
 */
export const transactionTeamEndpoints = {
  transactionTeams: `${ENV}/transactionteams`,
  transactionTeamDetails: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}`,
  newTransactionTeam: `${ENV}/transactionteam/new`,
  transactionRoles: `${ENV}/transactionroles`,
  transactionRoleDetails: (aimTransactionRole: Pick<TransactionRole, 'aimTransactionRole'>) =>
    `${ENV}/transactionrole/${aimTransactionRole}`,
  deleteTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}`,
  cancelTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/cancel`,
  submitTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/submit`,
  revertTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/revert`,
  formTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/form`,
  archiveTransactionTeam: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/archive`,
  updateTransactionTeam: (aimTransactionTeam: number) => `${ENV}/transactionteam/${aimTransactionTeam}`,
  changeMilestone: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/changemilestone`,
  raiseTransactionTeamPriority: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/priority/raise`,
  lowerTransactionTeamPriority: (aimTransactionTeam: Pick<TransactionTeam, 'aimTransactionTeam'>) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/priority/lower`,
  proposeTransactionTeamLead: (payload: TransactionTeamLeadParams) =>
    `${ENV}/transactionteam/${payload.aimTransactionTeam?.aimTransactionTeam}/lead/${payload.role?.aimTransactionRole}/propose`,
  approveTransactionTeamLead: (payload: TransactionTeamTransactionRoleParams) =>
    `${ENV}/transactionteam/${payload.aimTransactionTeam?.aimTransactionTeam}/lead/${payload.role?.aimTransactionRole}/approve`,
  replaceTransactionTeamLead: (payload: TransactionTeamLeadParams) =>
    `${ENV}/transactionteam/${payload.aimTransactionTeam?.aimTransactionTeam}/lead/${payload.role?.aimTransactionRole}/replace`,
  deleteTransactionTeamLead: (payload: TransactionTeamTransactionRoleParams) =>
    `${ENV}/transactionteam/${payload.aimTransactionTeam}/lead/${payload.role}`,
  addJarvisData: (aimTransactionTeam: number) => `${ENV}/transactionteam/${aimTransactionTeam}/jarvis`,
  getPropertySummary: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/propertysummary`,
  addPropertySummaryItem: (aimTransactionTeam: number, key: string) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/propertysummary/${key}`,
  propertySummaryChangeLog: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/propertysummary/changelog`,
  rejectTransaction: (aimTransactionTeam: number) => '',
  failTransaction: (aimTransactionTeam: number) => '',
  editTransactionTitle: (aimTransactionTeam: number) =>
      `${ENV}/transactionteam/${aimTransactionTeam}/changetitle`,
  editClosingDate: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/closingdate`,
  editClosingAcreage: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/closingacreage`,
  editClosingPrice: (aimTransactionTeam: number) =>
    `${ENV}/transactionteam/${aimTransactionTeam}/closingprice`
};
